import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = () => (
  <div className="spinnerWrapper">

  </div>
);

export default LoadingSpinner;